import { Gallery1, Gallery2, Gallery3, Gallery4, Gallery5, Gallery6, Gallery7 } from "@/components/Gallery";
import { Builder } from "@builder.io/react";
import { registerMenuGroups, commonInputs } from "./helper";

const galleryGroups = [
  {
    name: "Gallery Components",
    items: [
      { name: "Gallery 1" },
      { name: "Gallery 2" },
      { name: "Gallery 3" },
      { name: "Gallery 4" },
      { name: "Gallery 5" },
      { name: "Gallery 6" },
      { name: "Gallery 7" }
    ]
  },
];

export const registerGalleryComponents = () => {
  registerMenuGroups(galleryGroups);

  // Gallery Components
  Builder.registerComponent(Gallery1, {
    name: "Gallery 1",
    friendlyName: "Gallery 1",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "galleryItems",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            title: "Title 1",
            content: "Content 1",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            title: "Title 2",
            content: "Content 2",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            title: "Title 3",
            content: "Content 3",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 4",
            title: "Title 4",
            content: "Content 4",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 5",
            title: "Title 5",
            content: "Content 5",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Gallery2, {
    name: "Gallery 2",
    friendlyName: "Gallery 2",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "galleryItems",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            title: "Title 1",
            content: "Content 1",
            link: "/",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            title: "Title 2",
            content: "Content 2",
            link: "/",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            title: "Title 3",
            content: "Content 3",
            link: "/",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 4",
            title: "Title 4",
            content: "Content 4",
            link: "/",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 5",
            title: "Title 5",
            content: "Content 5",
            link: "/",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 6",
            title: "Title 6",
            content: "Content 6",
            link: "/",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeLink: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Gallery3, {
    name: "Gallery 3",
    friendlyName: "Gallery 3",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "galleryItems",
        type: "list",
        defaultValue: [
          {
            tabTitle: "Tab Title 1",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            title: "Title 1",
            content: "Content 1",
            link: "/",
            badges: [
              {
                badge: "Badge 1",
              },
              {
                badge: "Badge 2",
              },
              {
                badge: "Badge 3",
              },
            ],
          },
          {
            tabTitle: "Tab Title 2",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            title: "Title 2",
            content: "Content 2",
            link: "/",
            badges: [
              {
                badge: "Badge 1",
              },
              {
                badge: "Badge 2",
              },
              {
                badge: "Badge 3",
              },
            ],
          },
          {
            tabTitle: "Tab Title 3",
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            title: "Title 3",
            content: "Content 3",
            link: "/",
            badges: [
              {
                badge: "Badge 1",
              },
              {
                badge: "Badge 2",
              },
              {
                badge: "Badge 3",
              },
            ],
          },
          {
            tabTitle: "Tab Title 4",
            image: "/placeholder.svg",
            imageAltText: "Image 4",
            title: "Title 4",
            content: "Content 4",
            link: "/",
            badges: [
              {
                badge: "Badge 1",
              },
              {
                badge: "Badge 2",
              },
              {
                badge: "Badge 3",
              },
            ],
          },
          {
            tabTitle: "Tab Title 5",
            image: "/placeholder.svg",
            imageAltText: "Image 5",
            title: "Title 5",
            content: "Content 5",
            link: "/",
            badges: [
              {
                badge: "Badge 1",
              },
              {
                badge: "Badge 2",
              },
              {
                badge: "Badge 3",
              },
            ],
          },
          {
            tabTitle: "Tab Title 6",
            image: "/placeholder.svg",
            imageAltText: "Image 6",
            title: "Title 6",
            content: "Content 6",
            link: "/",
            badges: [
              {
                badge: "Badge 1",
              },
              {
                badge: "Badge 2",
              },
              {
                badge: "Badge 3",
              },
            ],
          },
        ],
        subFields: [
          {
            name: "tabTitle",
            type: "string",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
          {
            name: "badges",
            type: "list",
            subFields: [
              {
                name: "badge",
                type: "string",
              },
            ],
          }
        ],
      },
    ],
  });

  Builder.registerComponent(Gallery4, {
    name: "Gallery 4",
    friendlyName: "Gallery 4",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "galleryItems",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            title: "Title 1",
            content: "Content 1",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            title: "Title 2",
            content: "Content 2",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            title: "Title 3",
            content: "Content 3",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 4",
            title: "Title 4",
            content: "Content 4",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 5",
            title: "Title 5",
            content: "Content 5",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeSubtitle: true,
            includeContent: true,
            includeIcon: true,
            includeLink: true,
          }),

        ],
      },
    ],
  });

  Builder.registerComponent(Gallery5, {
    name: "Gallery 5",
    friendlyName: "Gallery 5",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "galleryItems",
        type: "list",
        defaultValue: [
          {
            tabTitle: "Tab Title 1",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            title: "Title 1",
            content: "Content 1",
            link: "/",
            icon: "mail",
          },
          {
            tabTitle: "Tab Title 2",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            title: "Title 2",
            content: "Content 2",
            link: "/",
            icon: "mail",
          },
          {
            tabTitle: "Tab Title 3",
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            title: "Title 3",
            content: "Content 3",
            link: "/",
            icon: "mail",
          },
          {
            tabTitle: "Tab Title 4",
            image: "/placeholder.svg",
            imageAltText: "Image 4",
            title: "Title 4",
            content: "Content 4",
            link: "/",
            icon: "mail",
          },
          {
            tabTitle: "Tab Title 5",
            image: "/placeholder.svg",
            imageAltText: "Image 5",
            title: "Title 5",
            content: "Content 5",
            link: "/",
            icon: "mail",
          },
          {
            tabTitle: "Tab Title 6",
            image: "/placeholder.svg",
            imageAltText: "Image 6",
            title: "Title 6",
            content: "Content 6",
            link: "/",
            icon: "mail",
          },
        ],
        subFields: [
          {
            name: "tabTitle",
            type: "string",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeIcon: true,
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          })
        ],
      },
    ],
  });

  Builder.registerComponent(Gallery6, {
    name: "Gallery 6",
    friendlyName: "Gallery 6",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "galleryItems",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Image 1",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 2",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 3",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 4",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 5",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 6",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 7",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 8",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Gallery7, {
    name: "Gallery 7",
    friendlyName: "Gallery 7",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      {
        name: "galleryItems",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            hasIconBadge: true,
            icon1: "mail",
            icon2: "mail",
            text: "Text 1",
            title: "Title 1",
            content: "Content 1",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            hasIconBadge: true,
            icon1: "mail",
            icon2: "mail",
            text: "Text 2",
            title: "Title 2",
            content: "Content 2",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            hasIconBadge: true,
            icon1: "mail",
            icon2: "mail",
            text: "Text 3",
            title: "Title 3",
            content: "Content 3",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          {
            name: "hasIconBadge",
            type: "boolean",
          },
          {
            name: "icon1",
            type: "string",
            showIf: `options.get('hasIconBadge') === true`,
          },
          {
            name: "icon2",
            type: "string",
            showIf: `options.get('hasIconBadge') === true`,
          },
          {
            name: "text",
            type: "string",
            showIf: `options.get('hasIconBadge') === true`,
          },
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
          }),
        ],
      },
    ],
  });
};
